export function calcDiscountBrlFromCommissionUsdt(params: {
  commissionConfirmedUsdt: number
  multiplierX: number
  usdtBrlRate: number
}): number {
  const commission = Number(params.commissionConfirmedUsdt || 0)
  const mult = Number(params.multiplierX || 0)
  const rate = Number(params.usdtBrlRate || 0)
  if (!Number.isFinite(commission) || !Number.isFinite(mult) || !Number.isFinite(rate)) return 0
  if (commission <= 0 || mult <= 0 || rate <= 0) return 0
  return (commission / mult) * rate
}

export function daysUntil(isoEnd: string, nowMs: number = Date.now()): number {
  const endMs = Date.parse(isoEnd)
  if (!Number.isFinite(endMs)) return 0
  const diffMs = endMs - nowMs
  return Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)))
}

